import request from "../../utils/request";
import { Result } from "../../models/general";
import { CompanyClaimTypeInput, CompanyClaimTypeView, UserClaimInput, UserClaimView } from "../../models/payroll";

export async function getCompanyClaimTypes() {
    const response=await request.get<Result<CompanyClaimTypeView[]>>("Claim/GetCompanyClaimTypes");
    return response.data;
}

export async function getCompanyClaimTypesWithStats() {
    const response=await request.get<Result<CompanyClaimTypeView[]>>("Claim/GetCompanyClaimTypesWithStats");
    return response.data;
}

export async function deleteCompanyClaimType(claimTypeId: number) {
    const response=await request.post<Result<CompanyClaimTypeView[]>>(`Claim/DeleteCompanyClaimType/${claimTypeId}`);
    return response.data;
}

export async function getCompanyClaimType(claimTypeId: number) {
    const response=await request.get<Result<CompanyClaimTypeView>>(`Claim/GetCompanyClaimType/${claimTypeId}`);
    return response.data;
}

export async function editCompanyClaimType(claimTypeId: number) {
    const response=await request.post<Result<CompanyClaimTypeView>>(`Claim/EditCompanyClaimType/${claimTypeId}`);
    return response.data;
}

export  async function getNumberOfBeneficiariesOfClaimType(claimTypeId: number) {
    const response= await request.get<number>(`Claim/GetNumberOfBeneficiariesOfClaimType/${claimTypeId}`);
    return response.data;
}

export async function addCompanyClaimType(input: CompanyClaimTypeInput) {
    const response=await request.post<Result<CompanyClaimTypeView>>("Claim/AddCompanyClaimType", input);
    return response.data;
}

export async function getUserClaim(claimId: number) {
    const response=await request.get<Result<UserClaimView>>(`Claim/GetUserClaim/${claimId}`);
    return response.data;
}

export async function getMyClaims(currencyId: number) {
    const response=await request.get<Result<UserClaimView[]>>(`Claim/GetMyClaims/${currencyId}`);
    return response.data;
}

export async function getUsersClaims(currencyId: number) {
    const response=await request.get<Result<UserClaimView[]>>(`Claim/GetUsersClaims/${currencyId}`);
    return response.data;
}

export async function addUserClaim(claimInput: UserClaimInput) {
    const response = await request.post<Result<UserClaimView>>(`Claim/AddUserClaim`, claimInput);
    return response.data;
}

export async function addUserClaimAttachments(claimId: number, attachments: File[]) {
    const formData = new FormData();
    attachments.forEach((file, index) => {
        formData.append(`attachments`, file);
    });

    const response = await request.post<Result<UserClaimView>>(`Claim/AddUserClaimAttachments/${claimId}`, formData, {
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    });
    return response.data;
}

export async function previewClaimAttachment(attachmentId: number) {
    const response = await request.get<Blob>(`Claim/PreviewClaimAttachment/${attachmentId}`, {
        responseType: 'blob',
    });
    return response.data;
}

export async function editUserClaim(claimId: number, claimInput: UserClaimInput) {
    const response = await request.post<Result<UserClaimView>>(`Claim/EditUserClaim/${claimId}`, claimInput);
    return response.data;
}
